import React from 'react';
import TodayBookingRevenueTable from './TodayBookingRevenueTable';

const TodayBookingRevenueList = () => {
  return (
    <div className="row m-0">
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Today's Booking Revenue Detailed Report</h4>
            <p className="card-subtitle mb-4">
              List of all bookings revenue for today.
            </p>
            <TodayBookingRevenueTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodayBookingRevenueList;
